<template>
  <div class="product-extra-content-item">
    <div class="product-extra-content-item__image-container">
      <image-element
        class="product-extra-content-item__img"
        v-if="content.images"
        :src="[content.images.big]"
        :src-mobile="[content.images.bigMobile]"
        :alt="content.subHeadline"
      />
    </div>
    <div class="product-extra-content-item__box">
      <header
        class="product-extra-content-item__header | headline h2"
        :class="{
          'product-extra-content-item__header--padding': content.externalUrl
        }"
        v-html="content.subHeadline"
        v-if="content.subHeadline"
      />
      <header
        class="product-extra-content-item__header | headline h2"
        v-html="content.label"
        v-if="!content.subHeadline && content.label && !content.externalUrl"
      />
      <span
        class="product-extra-content-item__text"
        :class="{
          'product-extra-content-item__text--padding': content.externalUrl
        }"
        v-if="content.introText"
        v-html="content.introText"
      />
      <div
        class="product-extra-content-item__cta-container"
        v-if="content.externalUrl"
      >
        <a
          :href="content.externalUrl"
          class="product-extra-content-item__cta"
          v-html="content.label"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import LazyLoad from '../lazyLoad/lazyLoad.vue';
  import ImageElement from '../imageElement/imageElement.vue';
  import type ProductExtraContent from '../../types/ProductExtraContent';

  @Options({
    name: 'product-extra-content-item',
    components: {
      ImageElement,
      LazyLoad,
    }
  })
  export default class ProductExtraContentItem extends Vue {
    @Prop()
    content: ProductExtraContent;
  }
</script>
